import { h } from 'vue'
import { Quasar, Meta, Dialog } from 'quasar'
import langDe from 'quasar/lang/de'
import { createPinia } from 'pinia'
import createRouter from 'src/router/index'
import applyComponentDefaults from 'ui-common/orders/helpers/componentDefaults'
import { bootFiles } from 'src/boot/index'
import mock from 'boot/mock.js'
import { setMockConfig } from 'boot/mockConfig'
import { provideCommonStores, contextConfigurationInjectionKey, masterdataInjectionKey } from 'ui-common/base/composables/useCommonStores'
import { useContextConfigurationStore } from 'src/stores/contextConfiguration'

import { attachErrorHandler } from '@sentry/vue'

import App from 'src/App.vue'

import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
import '@quasar/extras/material-symbols-outlined/material-symbols-outlined.css'
import '@wilken8/control-ui-common/css/_base.scss'

import 'src/css/app.scss'
import { useMasterdataStore } from 'src/stores/masterdata'

export const render = () => {
  const app = h(App, { isMfe: true })
  return app
}

export const handleInstance = async (app, opts) => {
  attachErrorHandler(app, {
    attachProps: false,
    logErrors: true
  })
  const pinia = createPinia()

  let router = typeof createRouter === 'function' ? createRouter({ base: opts.routerBase }) : createRouter

  if (router instanceof Promise) {
    router = await router
  }

  // mock
  if (process.env.DEV && window.localStorage.getItem('mock.enabled') !== 'false') {
    setMockConfig()
  }
  await mock({ backendBase: (opts.routerBase + opts.backendBase).replace(/\/\//g, '/') ?? '/' })

  applyComponentDefaults(null, app)

  const importedBootFiles = await Promise.all(bootFiles)
  await Promise.all(importedBootFiles.map(module => module.default({ app, router })))
  // app.provide('backendBase', opts.backendBase)

  app.use(Quasar, { plugins: { Dialog, Meta }, lang: langDe })
  app.use(pinia)
  app.use(router)

  provideCommonStores(app, {
    [contextConfigurationInjectionKey]: () => useContextConfigurationStore(),
    [masterdataInjectionKey]: () => useMasterdataStore()
  })
  // await bootMFE(app, router, opts)
}
